/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react/function-component-definition */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { Logger } from '@feature-hub/core';
import { ContentChangeListener, ContentServiceV1 } from '@oneaudi/content-service';
import { VueFormatterFeatureServiceInterfaceV1 } from '@oneaudi/vue-formatter-service/lib/cjs/v1/vue-formatter-feature-service';
import { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import React, { useState, useEffect } from 'react';
import { ContentContext } from './ContentContext';
import type { EditorJsonContent, FalconContent, TilesContent } from './contentTypes';
import { mapFaceContent, mapHeadlessContent } from './utils/mappers';

// START EMBER
import { getPersonalizedTiles } from '../../__ember__personalization/getPersonalizedTiles';
// END EMBER

export const ContentContextProvider: React.FC<{
  contentService: ContentServiceV1;
  vueFormatterService: VueFormatterFeatureServiceInterfaceV1;
  logger?: Logger;
  children?: React.ReactNode;
  localeService?: LocaleServiceV1;
}> = ({ contentService, vueFormatterService, logger, children, localeService }) => {
  // START EMBER
  const [debugTiles, setDebugTiles] = useState('normal');
  const [personalizedResults, setPersonalizedResults] = useState<unknown>(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setPersonalizedResults(
        JSON.parse(window.localStorage.getItem('personalizedResults') || 'null'),
      );
    }
  }, []);
  // END EMBER

  const [content, setContent] = useState(
    contentService.getContent() as FalconContent | EditorJsonContent,
  );
  contentService.onContentChange(setContent as ContentChangeListener);

  let tilesContent: TilesContent;
  if (content.__type === 'aem-headless') {
    logger?.info('aem-headless-content:', content);
    tilesContent = mapHeadlessContent(content);
  } else {
    tilesContent = mapFaceContent(content);
  }

  // START EMBER
  let isPersonalized;
  let isInContentTileMode;
  if (tilesContent.personalizationData) {
    const { isPersonalized: _isPersonalized, tiles } = getPersonalizedTiles({
      personalizedResults,
      personalizationData: tilesContent.personalizationData,
      tiles: tilesContent.tiles,
      debug: debugTiles === 'normal' ? null : debugTiles,
    });
    isPersonalized = _isPersonalized;
    isInContentTileMode = false;
    tilesContent.tiles = tiles;
  } else {
    isPersonalized = false;
    isInContentTileMode = true;
  }
  // END EMBER

  return (
    <ContentContext.Provider
      value={{
        content: tilesContent,
        vueFormatterService,
        localeService,
        // START EMBER
        setPersonalizedResults,
        personalizedResults,
        isPersonalized,
        isInContentTileMode,
        debugTiles,
        setDebugTiles,
        // END EMBER
      }}
    >
      {children}
    </ContentContext.Provider>
  );
};

ContentContextProvider.displayName = 'ContentContextProvider';
